<template>
  <div class="mdl-dialog modal-container center">
    <div class="mdl-dialog__content">
      <i class="material-icons big-icon">error</i>

      <h1 class="headline">Error revoking submissions</h1>

      <p>
        There was an error with the request to revoke your submissions. Please
        contact
        <a href="mailto:voters@getquorum.com" target="_new">
          voters@getquorum.com
        </a>
        for assistance.
      </p>

      <p>
        <small>Error: {{ error.message }}</small>
      </p>
    </div>
    <div class="mdl-dialog__actions">
      <button
        type="button"
        @click="$emit('close-modal')"
        class="mdl-button mdl-js-button mdl-button--raised"
      >
        <i class="material-icons">close</i>
        Close
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    error: {
      type: [Error, Object],
      default() {
        return {};
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/RevokeModal/RevokeModalResponseError.vue